var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "b-container",
        {
          staticClass: "flex-grow-1 d-flex flex-column h-100",
          attrs: { fluid: "" }
        },
        [
          _c(
            "b-row",
            { staticClass: "flex-shrink-0" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-card-group",
                    { staticClass: "couriers" },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "controlCouriers",
                          attrs: { "no-body": "" }
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "h-100",
                              attrs: { variant: "danger" },
                              on: {
                                click: function($event) {
                                  return _vm.openShiftModal()
                                }
                              }
                            },
                            [_c("icon", { attrs: { name: "flag-checkered" } })],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "perfect-scrollbar",
                        { staticClass: "d-flex couriers-ps" },
                        _vm._l(_vm.couriersOnWork, function(cour) {
                          return _c(
                            "b-card",
                            {
                              key: cour.id,
                              class: {
                                activeIt: _vm.selectedCourier === cour.id
                              },
                              attrs: { "no-body": "" },
                              on: {
                                click: function($event) {
                                  return _vm.selectCourier(cour)
                                }
                              }
                            },
                            [
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "mb-0 d-flex flex-row justify-content-between",
                                  attrs: { slot: "header" },
                                  slot: "header"
                                },
                                [
                                  _c("div", { staticClass: "courier-info" }, [
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(cour.id) +
                                            " - " +
                                            _vm._s(_vm.shortNameWorker(cour))
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(_vm._s(cour.phoneNumber))
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "px-2 py-0 pb-1",
                                      attrs: { variant: "danger" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openModalCloseShift(cour)
                                        }
                                      }
                                    },
                                    [_c("icon", { attrs: { name: "times" } })],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-list-group",
                                {
                                  staticClass: "courier-statuses",
                                  attrs: { flush: "" }
                                },
                                [
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "\n                                  " +
                                            _vm._s(
                                              cour.status &&
                                                _vm.courierStages.length !== 0
                                                ? cour.status.name
                                                : _vm.courierStageWaiting
                                                ? _vm.courierStageWaiting.name
                                                : ""
                                            ) +
                                            "\n                                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      cour.status &&
                                      cour.status.keyword ===
                                        _vm.STATUS_WORKER.DELIVERED
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "px-2 py-0 pb-1",
                                                  attrs: { variant: "success" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.courierArrived(
                                                        cour
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("icon", {
                                                    attrs: { name: "check" }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        {
                          staticClass: "controlCouriers",
                          attrs: { "no-body": "" }
                        },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.addCourier",
                                  modifiers: { addCourier: true }
                                }
                              ],
                              staticClass: "h-100",
                              attrs: { variant: "success" },
                              on: { click: _vm.getCouriersFree }
                            },
                            [_c("icon", { attrs: { name: "plus" } })],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    { attrs: { id: "addCourier", "ok-only": "" } },
                    [
                      _vm.couriersFree.length === 0
                        ? _c("span", [_vm._v("Свободных курьеров не найдено")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.couriersFree, function(cour) {
                        return _c(
                          "b-card",
                          {
                            key: cour.id,
                            staticClass: "mb-2",
                            attrs: { "no-body": "" }
                          },
                          [
                            _c(
                              "b-list-group",
                              { attrs: { flush: "" } },
                              [
                                _c("b-list-group-item", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mb-0 d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(cour.id) +
                                            " - " +
                                            _vm._s(_vm.fullNameWorker(cour)) +
                                            " - " +
                                            _vm._s(cour.phoneNumber)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "h-100",
                                          attrs: { variant: "success" },
                                          on: {
                                            click: function($event) {
                                              return _vm.changeCourierStatus(
                                                cour,
                                                true
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("icon", {
                                            attrs: { name: "plus" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "flex-grow-1" },
            [
              _c(
                "b-col",
                {
                  staticClass: " d-flex flex-column h-100",
                  attrs: { md: "3" }
                },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "my-3 flex-grow-1 h-100",
                      attrs: { "no-body": "" }
                    },
                    [
                      _c(
                        "b-tabs",
                        {
                          staticClass:
                            "flex-grow-1 tabs-delivery d-flex flex-column",
                          attrs: {
                            card: "",
                            "content-class":
                              "d-flex flex-column flex-grow-1 flex-tab"
                          }
                        },
                        [
                          _c(
                            "b-tab",
                            {
                              staticClass: "px-0 py-0 flex-grow-1 h-100",
                              attrs: { title: "На доставку" }
                            },
                            [
                              _c(
                                "perfect-scrollbar",
                                {
                                  staticClass:
                                    "flex-basis-0 flex-grow-1 deliveries-orders",
                                  attrs: { options: _vm.opsScroll }
                                },
                                [
                                  _c(
                                    "b-list-group",
                                    {
                                      staticClass: "orders",
                                      attrs: { flush: "" }
                                    },
                                    [
                                      _vm.deliveryOrders.length === 0
                                        ? _c(
                                            "b-card-body",
                                            { staticClass: "text-center" },
                                            [_vm._v("Нет заказов в работе")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(_vm.deliveryOrders, function(ord) {
                                        return _c(
                                          "b-list-group-item",
                                          {
                                            key: ord.id,
                                            class: {
                                              activeIt: _vm.selectedOrders.includes(
                                                ord.id
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.switchItems(
                                                  _vm.selectedOrders,
                                                  ord.id,
                                                  "orderCollecting"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("order-block", {
                                              attrs: {
                                                type: "delivery",
                                                order: ord,
                                                "order-stages":
                                                  _vm.orderStagesObj
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-toggle",
                                                    rawName: "v-b-toggle",
                                                    value: "deliv-" + ord.id,
                                                    expression:
                                                      "'deliv-' + ord.id"
                                                  }
                                                ],
                                                staticClass: "mt-1",
                                                attrs: { variant: "primary" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    Продукты\n                                    "
                                                ),
                                                _c("icon", {
                                                  attrs: {
                                                    title: "Продукты",
                                                    name: "shopping-cart"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-collapse",
                                              {
                                                staticClass: "mt-1",
                                                attrs: { id: "deliv-" + ord.id }
                                              },
                                              _vm._l(ord.prods.nodes, function(
                                                product
                                              ) {
                                                return _c(
                                                  "b-card",
                                                  { key: product.id },
                                                  [
                                                    _vm._v(
                                                      "\n                                      " +
                                                        _vm._s(product.name) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.deliveryOrders.length !== 0 &&
                              _vm.CAA_IS_ON === false &&
                              _vm.IS_SUPER_LOGISTICIAN
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.selectedOrders.length === 0,
                                        variant: "success",
                                        size: "sm w-100 mb-1 mt-1"
                                      },
                                      on: { click: _vm.unionOrders }
                                    },
                                    [
                                      _vm._v(
                                        "\n                              Объединить\n                            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            {
                              staticClass: "px-0 py-0 flex-grow-1 h-100",
                              attrs: { title: "Самовывоз" }
                            },
                            [
                              _c(
                                "perfect-scrollbar",
                                {
                                  staticClass:
                                    "flex-grow-1 flex-basis-0 pickup-orders",
                                  attrs: { options: _vm.opsScroll }
                                },
                                [
                                  _vm.pickupOrders.length === 0
                                    ? _c(
                                        "b-card-body",
                                        { staticClass: "text-center" },
                                        [_vm._v("Нет заказов в работе")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.pickupOrders, function(order) {
                                    return _c(
                                      "b-card",
                                      { key: order.id },
                                      [
                                        _c("order-block", {
                                          directives: [
                                            {
                                              name: "b-toggle",
                                              rawName: "v-b-toggle",
                                              value: "delivery-" + order.id,
                                              expression:
                                                "'delivery-' + order.id"
                                            }
                                          ],
                                          staticClass: "pointer",
                                          attrs: {
                                            type: "delivery",
                                            order: order,
                                            "order-stages": _vm.orderStagesObj
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "b-collapse",
                                          {
                                            attrs: {
                                              id: "delivery-" + order.id
                                            }
                                          },
                                          _vm._l(order.prods.nodes, function(
                                            product
                                          ) {
                                            return _c(
                                              "b-card",
                                              { key: product.id },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(product.name) +
                                                    "\n                                        "
                                                )
                                              ]
                                            )
                                          }),
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mt-1" },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { md: "6" } },
                                              [
                                                _c(
                                                  "b-btn",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      variant: "danger"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.cancelOrder(
                                                          order
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Отмена заказа\n                                            "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "6" } },
                                              [
                                                _c(
                                                  "b-btn",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      variant: "success"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.confirmOrder(
                                                          order
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Оплата\n                                            "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "checkbox-header mr-0",
                              attrs: {
                                id: "mapShowOrders",
                                value: "1",
                                "unchecked-value": "0"
                              },
                              model: {
                                value: _vm.mapShowOrders,
                                callback: function($$v) {
                                  _vm.mapShowOrders = _vm._n($$v)
                                },
                                expression: "mapShowOrders"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            На карте\n                        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                { attrs: { id: "ordersList", "body-class": "px-0 py-0" } },
                _vm._l(_vm.deliveryOrders, function(ord) {
                  return _c(
                    "b-list-group-item",
                    { key: ord.id, attrs: { "ok-only": "true" } },
                    [
                      _c("order-block", {
                        attrs: {
                          type: "delivery",
                          order: ord,
                          "order-stages": _vm.orderStagesObj
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "d-flex flex-column h-100", attrs: { md: "3" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "my-3 flex-grow-1",
                      attrs: { "no-body": "" }
                    },
                    [
                      _c(
                        "h6",
                        {
                          staticClass:
                            "mb-0 d-flex justify-content-between align-items-center",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _c(
                            "span",
                            [
                              _c("b", [_vm._v("Доставки:")]),
                              _vm._v(" "),
                              _c(
                                "b-badge",
                                {
                                  staticClass: "ml-1",
                                  attrs: { variant: "success" }
                                },
                                [_vm._v(_vm._s(_vm.selectedDeliveries.length))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _vm.isGivingToCourier
                                ? _c("b-spinner", {
                                    attrs: {
                                      type: "border",
                                      variant: "dark",
                                      small: ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    disabled: !_vm.permitGiveCourier,
                                    size: "sm",
                                    variant: "success"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.giveToCourier()
                                    }
                                  }
                                },
                                [_vm._v("Отдано")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.IS_SUPER_LOGISTICIAN
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.selectedDeliveries.length === 0 ||
                                      _vm.selectedCourier === null,
                                    size: "sm",
                                    variant: "success"
                                  },
                                  on: { click: _vm.appointCourier }
                                },
                                [_vm._v("Назначить")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "perfect-scrollbar",
                        {
                          staticClass: "flex-grow-1 flex-basis-0",
                          attrs: { options: _vm.opsScroll }
                        },
                        [
                          _c(
                            "b-list-group",
                            { staticClass: "deliveries", attrs: { flush: "" } },
                            [
                              _vm.deliveriesWork.length === 0
                                ? _c(
                                    "b-card-body",
                                    { staticClass: "text-center" },
                                    [_vm._v("Нет доставок в работе")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.deliveriesWork, function(del) {
                                return _c("delivery-item", {
                                  key: del.id,
                                  class: {
                                    activeIt: _vm.selectedDeliveries.includes(
                                      del.id
                                    )
                                  },
                                  attrs: {
                                    delivery: del,
                                    numberSelectedOrders:
                                      _vm.numberSelectedOrders,
                                    couriers: _vm.couriersOnWork,
                                    "order-stages": _vm.orderStagesObj,
                                    type: "delivery-list-in-work",
                                    CAA: _vm.CAA_IS_ON
                                  },
                                  on: {
                                    "change-courier": function($event) {
                                      return _vm.giveToCourier(
                                        $event.delivery,
                                        $event.courier
                                      )
                                    },
                                    "disband-delivery": function($event) {
                                      return _vm.disbandDelivery($event)
                                    },
                                    "add-order-to-delivery": function($event) {
                                      return _vm.addOrderToDelivery($event)
                                    }
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.switchItems(
                                        _vm.selectedDeliveries,
                                        del.id,
                                        "delivery"
                                      )
                                    }
                                  }
                                })
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.deliveriesList",
                                  modifiers: { deliveriesList: true }
                                }
                              ],
                              attrs: { size: "sm", variant: "primary" }
                            },
                            [
                              _vm._v(
                                "\n                          Все доставки "
                              ),
                              _c(
                                "b-badge",
                                {
                                  staticClass: "ml-1",
                                  attrs: { variant: "light" }
                                },
                                [_vm._v(_vm._s(_vm.deliveries.length))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "danger",
                                disabled: _vm.selectedDeliveries.length === 0
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setImportanceDelivery()
                                }
                              }
                            },
                            [_vm._v("Срочно")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "checkbox-header mr-0",
                              attrs: {
                                id: "mapShowDeliveries",
                                value: "1",
                                "unchecked-value": "0"
                              },
                              model: {
                                value: _vm.mapShowDeliveries,
                                callback: function($$v) {
                                  _vm.mapShowDeliveries = _vm._n($$v)
                                },
                                expression: "mapShowDeliveries"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            На карте\n                        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "deliveriesList",
                    "ok-only": "",
                    "body-class": "px-0 py-0"
                  },
                  on: { hide: _vm.deliveryListHide }
                },
                [
                  _c(
                    "b-list-group",
                    { staticClass: "deliveries", attrs: { flush: "" } },
                    [
                      _vm.deliveries.length === 0
                        ? _c("b-card-body", { staticClass: "text-center" }, [
                            _vm._v("Нет доставок в работе")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.deliveries, function(del) {
                        return _c("delivery-item", {
                          key: del.id,
                          attrs: {
                            type: "delivery-list-all",
                            delivery: del,
                            numberSelectedOrders: _vm.numberSelectedOrders,
                            couriers: _vm.couriersOnWork,
                            selectedOrders: _vm.selectedOrdersModal,
                            selectedDelivery: _vm.selectedDeliveryModal,
                            isInModal: true,
                            role: _vm.$user.get().role,
                            "order-stages": _vm.orderStagesObj
                          },
                          on: {
                            "update:selectedDelivery": function($event) {
                              _vm.selectedDeliveryModal = $event
                            },
                            "update:selected-delivery": function($event) {
                              _vm.selectedDeliveryModal = $event
                            },
                            "select-order": function($event) {
                              return _vm.selectOrder($event.order)
                            },
                            "change-courier": function($event) {
                              return _vm.giveToCourier(
                                $event.delivery,
                                $event.courier
                              )
                            },
                            "assign-courier": function($event) {
                              return _vm.assignToCourier(
                                $event.delivery,
                                $event.courier
                              )
                            },
                            "disband-delivery": function($event) {
                              return _vm.disbandDelivery($event)
                            },
                            "add-order-to-delivery": function($event) {
                              return _vm.addOrderToDelivery($event)
                            }
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "yandex-map",
                    {
                      staticClass: "my-3",
                      staticStyle: { width: "100%", height: "650px" },
                      attrs: {
                        coords: _vm.mapCenter,
                        zoom: "12",
                        "cluster-options": {
                          1: { clusterDisableClickZoom: true }
                        },
                        controls: [
                          "trafficControl",
                          "zoomControl",
                          "searchControl"
                        ],
                        "detailed-controls": {
                          searchControl: { provider: _vm.yandexSearchProvider }
                        }
                      },
                      on: { "map-was-initialized": _vm.initHandler }
                    },
                    _vm._l(_vm.placemarks, function(placemark) {
                      return _c("ymap-marker", {
                        key: placemark.markerId,
                        attrs: {
                          "marker-id": placemark.markerId,
                          "marker-type": placemark.markerType,
                          coords: placemark.coords,
                          icon: placemark.icon,
                          callbacks: {
                            click: _vm.markerClicked
                          },
                          properties: { iconCaption: placemark.iconCaption }
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("modal-payment-info", {
        ref: "modalPayment",
        attrs: { order: _vm.currentOrder, pickup: true },
        on: { "updated-payment": _vm.updatedPayment }
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "closeShift",
          attrs: {
            id: "closeShift",
            "modal-class": "fullSizeModal",
            size: "lg",
            title: "Закрытие смены",
            "ok-disabled":
              this.$moment(this.shiftDay).format("YYYY-MM-DD") !==
                this.$moment().format("YYYY-MM-DD") ||
              (_vm.currentShift && _vm.currentShift.dateClosed !== null),
            "ok-title": "Закрыть смену",
            "cancel-title": "Напечатать",
            "cancel-variant": "info",
            "cancel-disabled": _vm.couriersStats.length === 0
          },
          on: {
            ok: _vm.closeShift,
            hide: _vm.onHideCloseShiftModal,
            cancel: _vm.printCouriersReportOrders
          }
        },
        [
          _c("template", { slot: "modal-header" }, [
            _c(
              "div",
              [
                _c("b", { staticClass: "mr-2" }, [_vm._v("Смена:")]),
                _vm._v(" "),
                _c("el-date-picker", {
                  staticClass: "mr-2",
                  attrs: {
                    "picker-options": _vm.datePickerOptions,
                    "value-format": "yyyy-MM-dd",
                    format: "dd.MM.yyyy",
                    type: "date",
                    placeholder: "Выбрать день",
                    disabledDate: "disabledDate"
                  },
                  model: {
                    value: _vm.shiftDay,
                    callback: function($$v) {
                      _vm.shiftDay = $$v
                    },
                    expression: "shiftDay"
                  }
                }),
                _vm._v(" "),
                _vm.shiftOpened
                  ? _c("div", { staticClass: "d-inline" }, [
                      _c("span", { staticClass: "mr-1" }, [
                        _vm._v("Смена открыта: " + _vm._s(_vm.shiftOpened))
                      ]),
                      _vm._v(" "),
                      _vm.isShiftClosed === true
                        ? _c("span", { staticClass: "mr-1" }, [_vm._v("|")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShiftClosed === true
                        ? _c("span", { staticClass: "mr-1" }, [
                            _vm._v("Смена закрыта: " + _vm._s(_vm.shiftClosed))
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex mb-2" }, [
            _c("span", [
              _vm._v("Наведи, чтобы узнать что значит каждый цвет заказа")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ml-2" }, [
              _c("div", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true }
                  }
                ],
                staticClass: "rectangle",
                staticStyle: { "background-color": "rgb(226, 255, 230)" },
                attrs: {
                  title: "Заказ доставлен вовремя (приготовление - доставлен)"
                }
              }),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true }
                  }
                ],
                staticClass: "rectangle",
                staticStyle: { "background-color": "rgb(118, 234, 134)" },
                attrs: {
                  title:
                    "Курьер доставил заказ за соответствующее время, за что получит вознаграждение (отправлен - доставлен)"
                }
              }),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true }
                  }
                ],
                staticClass: "rectangle",
                staticStyle: { "background-color": "rgb(255, 204, 204)" },
                attrs: {
                  title:
                    "Заказ доставлен с опозданием (приготовление - доставлен)"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _vm.loadingCouriersOrders
            ? _c("b-spinner", {
                attrs: { type: "border", variant: "dark", small: "" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("b-table", {
            staticClass: "mb-0 table-orders",
            attrs: {
              hover: "",
              busy: _vm.loadingCouriersOrders,
              striped: "",
              "show-empty": "",
              "foot-clone": "",
              "empty-text": "Нет данных за текущую смену",
              fields: _vm.fieldsStat,
              items: _vm.couriersStats,
              "tbody-class": "scroll-y",
              "tbody-tr-class": _vm.rowClasses
            },
            on: { "row-clicked": _vm.toggleCourierOrders },
            scopedSlots: _vm._u([
              {
                key: "courier",
                fn: function(data) {
                  return [
                    _c("div", [_c("order-row", { attrs: { item: data } })], 1),
                    _vm._v(" "),
                    data.item.order &&
                    data.item.order.paymentChanged &&
                    !data.item.order.paymentChangingMarked
                      ? _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.confirmPaymentChanged(
                                  data.item.order
                                )
                              }
                            }
                          },
                          [_vm._v("Забили в айку")]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "FOOT_courier",
                fn: function(data) {
                  return [_c("b", [_vm._v("Общая сумма:")])]
                }
              },
              {
                key: "orderTotalTime",
                fn: function(data) {
                  return [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        attrs: {
                          title: "Время приготовления + сборка + доставка"
                        }
                      },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.getTimeTitle(data.item)) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                }
              },
              {
                key: "notEndedOrdersCount",
                fn: function(notEndedOrdersCount) {
                  return [
                    _c("span", [_vm._v(_vm._s(notEndedOrdersCount.value))])
                  ]
                }
              },
              {
                key: "cash",
                fn: function(cash) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(cash.value) +
                        " руб.\n            "
                    )
                  ]
                }
              },
              {
                key: "cardInPlace",
                fn: function(cardInPlace) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(cardInPlace.value) +
                        " руб.\n            "
                    )
                  ]
                }
              },
              {
                key: "cardOnline",
                fn: function(cardOnline) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(cardOnline.value) +
                        " руб.\n            "
                    )
                  ]
                }
              },
              {
                key: "sberbank",
                fn: function(sberbank) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(sberbank.value) +
                        " руб.\n            "
                    )
                  ]
                }
              },
              {
                key: "paymentLink",
                fn: function(paymentLink) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(paymentLink.value) +
                        " руб.\n            "
                    )
                  ]
                }
              },
              {
                key: "ordersCount",
                fn: function(ordersCount) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(ordersCount.value) +
                        "\n            "
                    )
                  ]
                }
              },
              {
                key: "total",
                fn: function(total) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(total.value) +
                        " руб.\n            "
                    )
                  ]
                }
              },
              {
                key: "salary",
                fn: function(data) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          data.item.salary +
                            (data.item.inTime && data.item.inTime.sum
                              ? data.item.inTime.sum
                              : 0)
                        ) +
                        " руб.\n            "
                    )
                  ]
                }
              },
              {
                key: "motivation",
                fn: function(data) {
                  return [
                    _vm._v(
                      "\n              " +
                        _vm._s(data.item.motivation) +
                        " руб.\n            "
                    )
                  ]
                }
              },
              {
                key: "gived",
                fn: function(data) {
                  return [
                    _vm._v(
                      "\n              " +
                        _vm._s(data.item.gived) +
                        " руб.\n            "
                    )
                  ]
                }
              },
              {
                key: "FOOT_salary",
                fn: function(data) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.sumSalary) +
                        " руб.\n            "
                    )
                  ]
                }
              },
              {
                key: "FOOT_motivation",
                fn: function(data) {
                  return [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.sumMotivation) +
                        " руб.\n            "
                    )
                  ]
                }
              },
              {
                key: "FOOT_cash",
                fn: function(data) {
                  return [_c("b", [_vm._v(_vm._s(_vm.sumCash) + " руб.")])]
                }
              },
              {
                key: "FOOT_cardInPlace",
                fn: function(data) {
                  return [
                    _c("b", [_vm._v(_vm._s(_vm.sumCardInPlace) + " руб.")])
                  ]
                }
              },
              {
                key: "FOOT_cardOnline",
                fn: function(data) {
                  return [
                    _c("b", [_vm._v(_vm._s(_vm.sumCardOnline) + " руб.")])
                  ]
                }
              },
              {
                key: "FOOT_sberbank",
                fn: function(data) {
                  return [_c("b", [_vm._v(_vm._s(_vm.sumSberbank) + " руб.")])]
                }
              },
              {
                key: "FOOT_paymentLink",
                fn: function(data) {
                  return [
                    _c("b", [_vm._v(_vm._s(_vm.sumPaymentLink) + " руб.")])
                  ]
                }
              },
              {
                key: "FOOT_total",
                fn: function(data) {
                  return [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.couriersStats.reduce(function(val, el) {
                            return (
                              val +
                              (el.courier || el.pickup ? parseInt(el.total) : 0)
                            )
                          }, 0)
                        ) + " руб."
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.currentShift
            ? _c(
                "div",
                { staticClass: "mt-5" },
                [
                  _vm.loadingSpending
                    ? _c("b-spinner", {
                        staticClass: "mb-1",
                        attrs: { small: "" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-table", {
                    staticClass: "mb-0 table-orders",
                    attrs: {
                      hover: "",
                      striped: "",
                      fixed: "",
                      busy: _vm.loadingSpending,
                      "foot-clone": "",
                      "show-empty": "",
                      "empty-text": "Дополнительных расходов внесено не было",
                      fields: [
                        {
                          key: "title",
                          label: "Трата"
                        },
                        {
                          key: "sum",
                          label: "Сумма"
                        },
                        {
                          key: "del",
                          label: "",
                          class: "icon-col"
                        }
                      ],
                      items: _vm.additionalSpending,
                      "tbody-class": "scroll-y",
                      "tbody-tr-class": "order-prods"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "del",
                          fn: function(data) {
                            return [
                              !data.item.hideDelete
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: { size: "md", variant: "danger" },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteSpending(data.item)
                                        }
                                      }
                                    },
                                    [
                                      _c("icon", {
                                        attrs: { name: "trash-alt" }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          }
                        },
                        {
                          key: "FOOT_title",
                          fn: function(data) {
                            return [_c("b", [_vm._v("Итого расходов:")])]
                          }
                        },
                        {
                          key: "FOOT_sum",
                          fn: function(data) {
                            return [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.additionalSpending.reduce(function(
                                      val,
                                      el
                                    ) {
                                      return val + parseFloat(el.sum)
                                    },
                                    0)
                                  ) + " руб."
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1535846777
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    {
                      staticClass:
                        "d-flex mt-3 justify-content-between align-items-end"
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-0 mr-2 flex-grow-2",
                              attrs: {
                                label: "Статья расходов:",
                                "label-for": "Input1"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "Input1",
                                  required: "",
                                  placeholder: "Введите статью расходов"
                                },
                                model: {
                                  value: _vm.spend.title,
                                  callback: function($$v) {
                                    _vm.$set(_vm.spend, "title", $$v)
                                  },
                                  expression: "spend.title"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "w-100 d-flex align-items-end",
                          attrs: { md: "6" }
                        },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-0 mr-3 flex-grow-1",
                              attrs: { label: "Сумма:", "label-for": "Input1" }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "Input1",
                                  type: "number",
                                  required: "",
                                  placeholder: "Введите сумму"
                                },
                                model: {
                                  value: _vm.spend.sum,
                                  callback: function($$v) {
                                    _vm.$set(_vm.spend, "sum", _vm._n($$v))
                                  },
                                  expression: "spend.sum"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { size: "md", variant: "success" },
                              on: {
                                click: function($event) {
                                  return _vm.addSpend()
                                }
                              }
                            },
                            [_vm._v("Добавить")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sumCash !== 0 ||
          _vm.sumSalary !== 0 ||
          _vm.sumCosts !== 0 ||
          _vm.sumInTime !== 0
            ? _c("b-list-group-item", { staticClass: "mt-5" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center"
                  },
                  [
                    _c("b", [_vm._v("Итого:")]),
                    _vm._v(" "),
                    _c(
                      "b",
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.top",
                                value: "Сумма заказов",
                                expression: "'Сумма заказов'",
                                modifiers: { hover: true, top: true }
                              }
                            ],
                            attrs: { variant: "outline-info" }
                          },
                          [_vm._v(_vm._s(_vm.sumCash))]
                        ),
                        _vm._v(" -\n                  "),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.top",
                                value: "Сумма заработанная курьерами",
                                expression: "'Сумма заработанная курьерами'",
                                modifiers: { hover: true, top: true }
                              }
                            ],
                            attrs: { variant: "outline-info" }
                          },
                          [_vm._v(_vm._s(_vm.sumSalary))]
                        ),
                        _vm._v(" -\n                  "),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.top",
                                value: "Сумма расходов",
                                expression: "'Сумма расходов'",
                                modifiers: { hover: true, top: true }
                              }
                            ],
                            attrs: { variant: "outline-info" }
                          },
                          [_vm._v(_vm._s(_vm.sumCosts))]
                        ),
                        _vm._v(" -\n                  "),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.top",
                                value: "Сумма мотивации курьеров",
                                expression: "'Сумма мотивации курьеров'",
                                modifiers: { hover: true, top: true }
                              }
                            ],
                            attrs: { variant: "outline-info" }
                          },
                          [_vm._v(_vm._s(_vm.sumMotivation))]
                        ),
                        _vm._v(" =\n                  "),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.top",
                                value: "Общая сумма",
                                expression: "'Общая сумма'",
                                modifiers: { hover: true, top: true }
                              }
                            ],
                            attrs: { variant: "outline-info" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.sumCash -
                                  _vm.sumSalary -
                                  _vm.sumMotivation -
                                  _vm.sumCosts
                              )
                            )
                          ]
                        ),
                        _vm._v(" руб.\n                ")
                      ],
                      1
                    )
                  ]
                )
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "courStat",
          attrs: {
            title: _vm.courierModal
              ? "Закрытие смены: " + _vm.fullNameWorker(_vm.courierModal)
              : "",
            "ok-title": "Закрыть смену курьера",
            "ok-disabled":
              _vm.courierModal &&
              (!_vm.courierModal.status ||
                _vm.courierModal.status.keyword !== _vm.STATUS_WORKER.WAITING),
            "ok-only": true
          },
          on: {
            ok: function($event) {
              return _vm.changeCourierStatus(_vm.courierModal, false)
            },
            hide: function($event) {
              _vm.courierModal = null
            }
          }
        },
        [
          _c("courier-stat-display", {
            ref: "courStats",
            attrs: { orders: _vm.courierStat }
          }),
          _vm._v(" "),
          _vm.courierModal
            ? [
                !_vm.courierModal.status ||
                _vm.courierModal.status.keyword !== _vm.STATUS_WORKER.WAITING
                  ? _c("div", { staticClass: "mt-2" }, [
                      _c("b", [
                        _vm._v(
                          "Перед закрытием смены, подтвердите возвращение курьера"
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("cancel-order-modal", {
        ref: "causeCancelOrder",
        attrs: {
          orderId: _vm.orderIdForCancel,
          statusOptions: _vm.orderStages
        },
        on: { "order-canceled": _vm.orderCanceled }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e8017a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e8017a9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrdersDelivery.vue
// module id = null
// module chunks = 